// placeholder for when we get round to adding bespoke admin routes
import AdminAppRoutes from './MemberAppRoutes'

export default AdminAppRoutes;